/* import __COLOCATED_TEMPLATE__ from './currency.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();